module.exports = __webpack_public_path__ + "img/green_134.a62ccfb7.png";